import React from "react";
import { useState, useEffect, useRef } from "react";
export const OTPInputHandler = ({ length, onChange, value = "", inputClassName = "" }) => {
    const [chars, setChars] = useState(() => Array(length).fill(""));
    const inputsRef = useRef([]);
    // Sync incoming `value` prop to the local state, once when it truly changes:
    useEffect(() => {
        const arr = Array(length).fill("");
        value
            .slice(0, length)
            .split("")
            .forEach((c, i) => (arr[i] = c));
        // only update if different
        if (arr.join("") !== chars.join("")) {
            setChars(arr);
        }
    }, [value, length]);
    const notifyParent = (newChars) => {
        onChange(newChars.join(""));
    };
    const fillFrom = (startIdx, digits) => {
        if (!digits)
            return;
        const next = [...chars];
        let cursor = startIdx;
        for (const d of digits) {
            if (cursor >= length)
                break;
            next[cursor] = d;
            cursor++;
        }
        setChars(next);
        notifyParent(next);
        const focusIdx = Math.min(cursor, length - 1);
        inputsRef.current[focusIdx]?.focus();
    };
    const handleChange = (e, idx) => {
        const cleaned = e.target.value.replace(/\D/g, "");
        if (cleaned.length > 1) {
            fillFrom(idx, cleaned.slice(0, length - idx));
            return;
        }
        const digit = cleaned.slice(-1);
        const next = [...chars];
        next[idx] = digit;
        setChars(next);
        notifyParent(next);
        if (digit && idx < length - 1) {
            inputsRef.current[idx + 1]?.focus();
        }
    };
    const handlePaste = (e, idx) => {
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
        if (!pasted)
            return;
        e.preventDefault();
        fillFrom(idx, pasted.slice(0, length - idx));
    };
    const handleKeyDown = (e, idx) => {
        if (e.key === "Backspace") {
            const next = [...chars];
            if (chars[idx] === "") {
                if (idx > 0) {
                    next[idx - 1] = "";
                    setChars(next);
                    notifyParent(next);
                    inputsRef.current[idx - 1]?.focus();
                }
            }
            else {
                next[idx] = "";
                setChars(next);
                notifyParent(next);
            }
            e.preventDefault();
        }
        else if (e.key === "ArrowLeft" && idx > 0) {
            inputsRef.current[idx - 1]?.focus();
            e.preventDefault();
        }
        else if (e.key === "ArrowRight" && idx < length - 1) {
            inputsRef.current[idx + 1]?.focus();
            e.preventDefault();
        }
    };
    return (React.createElement("div", { className: "flex gap-2 justify-center mb-6" }, chars.map((ch, i) => (React.createElement("input", { autoFocus: i === 0, key: i, ref: (el) => {
            if (el)
                inputsRef.current[i] = el;
        }, type: "text", inputMode: "numeric", autoComplete: "one-time-code", maxLength: 1, className: `
              w-12 h-12 text-center border rounded
              focus:border-primary focus:ring focus:ring-primary/50
              ${inputClassName}
            `, value: ch, onChange: (e) => handleChange(e, i), onKeyDown: (e) => handleKeyDown(e, i), onPaste: (e) => handlePaste(e, i) })))));
};
